import React from 'react';
import { useSetResolved } from 'src/core/engine/router';
import { Link } from 'react-router';

export const Offline = () => {
    useSetResolved();
    return (
        <>
            <p>It looks like you're offline - so some pages are not available.</p>
            <p>
                <Link to="/">Go to the homepage</Link>
            </p>
        </>
    );
};
